module.exports = __webpack_public_path__ + "static/fonts/notokr-light.251f03d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/self-diagnosis/font/notokr-light.woff2
// module id = 9lLX
// module chunks = 0